export default __webpack_public_path__ + "static/epica-lite-5-6acdc7b1075109ab69958f8a19b5eab1.jpg";